<template lang="html">
  <div id="action-bar" class="w-100 bg-white">
    <div class="divider w-100 dn-ns mh2 mv0"/>
    <div id="action-bar-content" class="flex items-center justify-between ph2 bg-white">
      <div class="left flex items-center">
        <slot name="left"></slot>
      </div>
      <div class="right flex items-center">
        <slot name="right"></slot>
      </div>
    </div>
    <div class="divider dn db-ns mh2 mv0"/>
  </div>
</template>

<script>
export default {
  name: 'app-action-bar'
};
</script>

<style lang="scss" scoped>
#action-bar {
  #action-bar-content {
    height: $action-bar-height;
  }

  @media screen and (max-width: $breakpoint-medium) {
    position: fixed;
    bottom: 0;
    z-index: 1;
  }

  @media screen and (min-width: $breakpoint-medium) {
    // this hides the right bar entirely on desktop. why you do dis kelly
    // position: fixed;
    z-index: 1;
    position: sticky;
    top: 0;
    bottom: auto;
  }
}

.divider {
  border: none;
  height: 1px;
  background: black;
}
</style>



// WEBPACK FOOTER //
// src/components/ActionBar.vue